import { Extension } from "../../core/extension";
import { SlashCommandGroup, } from "../../core/types";
import { ReactNodeView } from "../../react";
import { uploadAttachment } from "./commands";
import { AttachmentNodeView } from "./components/AttachmentNodeView/AttachmentNodeView";
import { ImageNodeView } from "./components/ImageNodeView/ImageNodeView";
import { VideoNodeView } from "./components/VideoNodeView/VideoNodeView";
import { filestackPickerPlugin } from "./plugins/filestack-picker.plugin";
import { filestackUploadPlugin } from "./plugins/filestack-upload.plugin";
import { imageMenuPlugin } from "./plugins/image-menu.plugin";
import { videoMenuPlugin } from "./plugins/video-menu-plugin";
import { filestackNodeSpecs } from "./schema";
export class FilestackExtension extends Extension {
    constructor(service) {
        super();
        this.service = service;
    }
    addPlugins(schema, plugins, { portalContainer }) {
        return plugins.concat([
            filestackUploadPlugin(this.service),
            imageMenuPlugin(portalContainer, this.service),
            videoMenuPlugin(portalContainer, this.service),
            filestackPickerPlugin(this.service),
        ]);
    }
    addNodes(nodes) {
        return nodes.append(filestackNodeSpecs(this.service));
    }
    getSlashCommand(mode) {
        return (match, view) => {
            view.dispatch(view.state.tr.deleteRange(match.range.from, match.range.to));
            uploadAttachment(view, mode);
        };
    }
    addSlashCommands(commands) {
        return [
            ...commands,
            {
                label: `Insert Image`,
                description: `Add images to your page`,
                group: SlashCommandGroup.Basics,
                icon: "is-image",
                shortcut: "I",
                command: this.getSlashCommand("image"),
            },
            {
                label: `Insert Video`,
                description: `Add videos to your page`,
                group: SlashCommandGroup.Basics,
                icon: "movie",
                shortcut: "Y",
                command: this.getSlashCommand("video"),
            },
            {
                label: `Insert Attachment`,
                description: `Add attachments to your page`,
                group: SlashCommandGroup.Basics,
                icon: "is-attachment",
                shortcut: "A",
                command: this.getSlashCommand("attachment"),
            },
        ];
    }
    addNodeViews(schema, nodeViews, portalContainer) {
        return {
            ...nodeViews,
            attachment: ReactNodeView.create({
                portalContainer,
                component: AttachmentNodeView,
                extraProps: {
                    service: this.service,
                },
            }),
            image: ReactNodeView.create({
                portalContainer,
                component: ImageNodeView,
                extraProps: { service: this.service },
            }),
            video: ReactNodeView.create({
                portalContainer,
                component: VideoNodeView,
                extraProps: { service: this.service },
            }),
        };
    }
}
